import { IValidationRule } from "@/types"

const tenantEmployeeValidationRules: { [s: string]: IValidationRule } = {
    forename: {
        required: true,
    },
    surname: {
        required: true,
    },
    number: {
        required: true,
    },
    email: {
        required: true,
        type: "email",
    },
    phoneNumber: {
        required: true,
    }
}

export default tenantEmployeeValidationRules
